import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar, { ThemeProvider } from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Stats from './components/Stats';
import Services from './components/Services';
import HowWeWork from './components/HowWeWork';
import TechnicalCapacity from './components/TechnicalCapacity';
import Philosophy from './components/Philosophy';
import Projects from './components/Projects';
import Clients from './components/Clients';
import PublicWork from './components/PublicWork';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { MessageCircle } from 'lucide-react';

const WA_LINK = 'https://wa.me/529514997959?text=' + encodeURIComponent('Hola, me interesa obtener una cotización de Grupo Constructor Yescas.');

const HomePage = () => {
  return (
    <div className="yescas-app">
      <Navbar />
      <Hero />
      <About />
      <Stats />
      <Services />
      <HowWeWork />
      <TechnicalCapacity />
      <Projects />
      <Clients />
      <PublicWork />
      <Testimonials />
      <Philosophy />
      <Contact />
      <Footer />
      {/* Floating WhatsApp Button */}
      <a href={WA_LINK} target="_blank" rel="noopener noreferrer" className="wa-float" title="Escríbenos por WhatsApp">
        <MessageCircle size={28} fill="white" strokeWidth={0} />
      </a>
    </div>
  );
};

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
